import { Injectable/*,Injector*/ } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

//import {AuthProvider} from '../../providers/auth/auth';

import { Events } from 'ionic-angular';
import { DomainEvents, User } from '../../models/models';

/*
Inietta api_token per utenti autenticati
*/
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private api_token: string;

	constructor(
		public events: Events,
	) {
		let self = this;
		events.subscribe(DomainEvents.USER_LOGIN, (user: User, _time) => {
			console.log('[AuthInterceptor.events.on(USER_LOGIN)] Ricevuta notifica di login, salvataggio api_token');
			self.api_token = user.api_token;
		});
		events.subscribe(DomainEvents.USER_LOGOUT, (_user: User, _time) => {
			console.log('[AuthInterceptor.events.on(USER_LOGIN)] Ricevuta notifica di logout, cancellazione api_token');
			self.api_token = null;
		});
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (this.api_token) {
			//request.params=
			//request.params.set('api_token',this.api_token);
			/*
			console.log('Parametri della richiesta orignale:',request.params);
			let params={...request.params};
			*/
			//params.append('api_token',this.api_token);
			//console.log('Parametri della nuova richiesta:',params);

			let headers = request.headers
				.set('Authorization', 'Bearer ' + this.api_token)
				.set('token', this.api_token)
				.set('api_token', this.api_token);
			request = request.clone({
				headers: headers,
				//				params:params
			});
			//request = request.clone({headers: request.headers.append('Authorization','Bearer '+this.api_token)});
			/*
			WORKAROUND BUG
			*/
			// Keeps the original request params. as a new HttpParams
			// Add any params (can also chain .append() but I was conditionally adding params)
			//let params = new HttpParams({fromString: request.params.toString()}).append('api_token',this.api_token);

			// Clone the request with params instead of setParams
			//request = request.clone({ params: params, body:request.body });
		}

		return next.handle(request);
	}
}



// WEBPACK FOOTER //
// ./src/interceptors/auth/auth.ts